// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headline[data-v-07e7ecfe]{background:hsla(0,0%,74.9%,.7)}.v-btn.yes[data-v-07e7ecfe]{background:#3ebb47!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
